import { render } from "./ZimuPage.vue?vue&type=template&id=9b66763c&scoped=true"
import script from "./ZimuPage.vue?vue&type=script&lang=js"
export * from "./ZimuPage.vue?vue&type=script&lang=js"

import "./ZimuPage.vue?vue&type=style&index=0&id=9b66763c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b66763c"]])

export default __exports__